export default "__VITE_ASSET__CmFYTSes__"